import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient';
import { createQueryHook } from '@fourthwall/utils/dist/queries';
const usePlatformAppClientQuery = createQueryHook(PlatformAppsApiClient.getPlatformAppClient, {
    queryKey: ['platformAppClient'],
});
export const usePlatformAppClient = (appId) => {
    const { platformAppClientQuery } = usePlatformAppClientQuery([{ clientId: appId }]);
    return {
        data: platformAppClientQuery.data,
        isLoading: platformAppClientQuery.isLoading,
        refetch: platformAppClientQuery.refetch,
    };
};
